const Wallet = ({ fill = "#141414", size = 18 }) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <path
      fill={fill}
      d="M18.9,7.6c0.5,0,0.8,0.4,0.8,0.8c0,0.4-0.3,0.8-0.7,0.8l-0.1,0l-13.7,0c-0.5,0-0.8-0.4-0.8-0.8
	C4.3,8,4.6,7.7,5,7.6l0.1,0L18.9,7.6z"
    />
    <path
      fill={fill}
      d="M23,8.5C23,6,21,4,18.6,4H5.4C3,4,1,6,1,8.5v9C1,19.9,3,22,5.4,22h13.2c2.4,0,4.4-2,4.4-4.5V8.5z M5.4,5.6h13.2
	l0.2,0c1.4,0.1,2.6,1.3,2.6,2.8v9l0,0.2c-0.1,1.5-1.3,2.6-2.7,2.6H5.4l-0.2,0c-1.4-0.1-2.6-1.3-2.6-2.8v-9l0-0.2
	C2.7,6.8,3.9,5.6,5.4,5.6z"
    />
    <path
      fill={fill}
      d="M16.3,1.1c1.2-0.3,2.4,0.4,2.7,1.7L19.3,4c0,0,0,0,0,0h-1.7l-0.2-0.9c-0.1-0.3-0.3-0.4-0.6-0.4l-0.1,0L11.4,4
	H4.9C4,4,3.3,4.5,2.9,5.2c0.2-0.5,0.6-0.9,1.2-1.1L16.3,1.1z"
    />
  </svg>
);

export default Wallet;
